import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { GuestListsState, GuestListResource } from './guest-lists.types'
import { setIncludedResources } from '~/utils/store'

const actions: ActionTree<GuestListsState, RootState> = {
  async fetchGuestList ({ commit }, id) {
    const { data, included } = await this.$sohoApi.get<GuestListResource>(`${SohoModel.GuestList}/${id}`, { include: ['invites'] })

    if (included) {
      setIncludedResources(included, commit)
    }

    commit('SET_GUEST_LIST', data)

    return data
  }
}

export default actions
